import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Container, { ContainerProps } from '@material-ui/core/Container';
import cx from 'clsx';

const useStyles = makeStyles<Theme>(() => ({
  root: {
    width: '100%'
  }
}));

export interface StepContainer extends ContainerProps {
  index: number | string;
  value: number | string;
}
const StepContainer: React.FC<StepContainer> = ({ children, index, value, className, ...rest }) => {
  const classes = useStyles();
  return (
    <Container
      disableGutters
      maxWidth={false}
      hidden={index !== value}
      className={cx(classes.root, className)}
      {...rest}
    >
      {children}
    </Container>
  );
};
export default StepContainer;
